module.exports = __webpack_public_path__ + "static/media/back.59c35fb6.jpg";